import axios from "axios";
import { RSAEncryption } from "../util/Cryptography";

import type { GetLocationByCustomerIdApiResponse, GetOneLocationRecordAPIResponse } from "../shared/interface/MasterManagement/locationMaster.interface";
import type { KeyFobListApiResponse, TotalCountParkingSlotKeyFobCountApiResponse } from "../shared/interface/MasterManagement/keyFobMaster.interface";
import type { ReqAckStatusListResponse } from "../shared/interface/MasterManagement/reqAckStatus.interface";

export const getLocationListByCustomerId = async (customerId: number) => {
  let query = `${process.env.REACT_APP_API_URL}/master-list/locationByCustomerId/${customerId}`;

  try {
    const response = await axios.get(query);

    return response.data as GetLocationByCustomerIdApiResponse;
  } catch (error) {
    throw error;
  }
};

export const getClientListByCustomerAndLocationId = async (customerId: number, locationId: number) => {
  let query = `${process.env.REACT_APP_API_URL}/master-list/clientByCustomerAndLocationId/${customerId}/${locationId}`;

  try {
    const response = await axios.get(query);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getKeyFobListByCustomerAndLocationId = async (customerId: number, locationId: number) => {
  let query = `${process.env.REACT_APP_API_URL}/master-list/keyFobTokenByCustomerAndLocationId/${customerId}/${locationId}`;

  try {
    const response = await axios.get(query);

    return response.data as KeyFobListApiResponse;
  } catch (error) {
    throw error;
  }
};

export const verifyMobileUserAndGetDetails = async (mobileNumber: string) => {
  const encryptedMobileNumber = RSAEncryption.encrypt(mobileNumber);

  let query = `${process.env.REACT_APP_API_URL}/master-list/verifyMobileUserAndGetDetails`;

  try {
    const response = await axios.post(query, { mobile_number: encryptedMobileNumber });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUnallocatedKeyFobListByCustomerAndLocationId = async (customerId: number, locationId: number, vehicleTypeId?: number) => {
  let query = `${process.env.REACT_APP_API_URL}/master-list/get-unallocated-keyfob-by-customer-location-id/${customerId}/${locationId}`;

  if (vehicleTypeId) {
    query += `?vehicleTypeId=${vehicleTypeId}`;
  }

  try {
    const response = await axios.get(query);

    return response.data as KeyFobListApiResponse;
  } catch (error) {
    throw error;
  }
};

export const getReqAckStatusList = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/master-list/req-ack-status-list`);
    return response.data as ReqAckStatusListResponse;
  } catch (error) {
    throw error;
  }
};

export const getTotalCountParkingSlotKeyFobCount = async (customerId: number, locationId: number) => {
  let query = `${process.env.REACT_APP_API_URL}/master-list/parking-keyfob-details/${customerId}/${locationId}`;

  try {
    const response = await axios.get(query);

    return response.data as TotalCountParkingSlotKeyFobCountApiResponse;
  } catch (error) {
    throw error;
  }
};
